import { render } from "./MenuItems.vue?vue&type=template&id=08d6b7ee&ts=true"
import script from "./MenuItems.vue?vue&type=script&lang=ts"
export * from "./MenuItems.vue?vue&type=script&lang=ts"

import "./MenuItems.vue?vue&type=style&index=0&id=08d6b7ee&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__